import { ScrollingModule } from '@angular/cdk/scrolling';
import { TextFieldModule } from '@angular/cdk/text-field';
import { CommonModule, DecimalPipe } from '@angular/common';
import { ModuleWithProviders, NgModule, Provider, Type } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { IonicModule } from '@ionic/angular';
import { RecentsModule } from 'apps/idl/src/modules/preferences/recents/recents.module';
import { OsappModule } from 'apps/idl/osapp.module';
import { IdlModalService } from '../../services/idl-modal.service';
import { IndemniteService } from '../../services/indemnite.service';
import { ActesModule } from '../actes/actes.module';
import { OrdonnancesModule } from '../ordonnances/ordonnances.module';
import { PatientsModule } from '../patients/patients.module';
import { PlanningRHModule } from '../planning-rh/planning-rh.module';
import { SeancesModule } from '../seances/seances.module';
import { AccordPrealableService } from './slides-traitement/accordPrealable/accordPrealable.service';
import { ValidateActesModule } from './validateActes/validate-actes.module';
import { PipeModule } from '../../pipes';

const modules: Array<Type<any> | ModuleWithProviders<any>> = [
	CommonModule,
	IonicModule,
	PipeModule,
	FormsModule,
	OsappModule,
	MatSelectModule,
	MatFormFieldModule,
	MatInputModule,
	TextFieldModule,
	MatExpansionModule,
	MatCheckboxModule,
	ValidateActesModule,
	ActesModule,
	PatientsModule,
	SeancesModule,
	ScrollingModule,
	PlanningRHModule,
	MatChipsModule,
	OrdonnancesModule,
	RecentsModule.forRoot({ limit: 3 }),
];
const components: Type<any>[] = [
];
const providers: Provider[] = [
	IndemniteService,
	IdlModalService,
	AccordPrealableService,
	DecimalPipe
];

/** Module de gestion des traitements. */
@NgModule({
	imports: modules,
	exports: components,
	declarations: components,
	providers: providers
})
export class TraitementSlideModule { }